import type { EventPayload } from './eventPayload';

const VOLUME_COMPARISONS = [
  {
    asset: 'motorcycle',
    subtitleKey: 'shareable.volumeCompare.motorcycle.subtitle',
    weightKg: 300,
  },
  {
    asset: 'shark',
    subtitleKey: 'shareable.volumeCompare.shark.subtitle',
    weightKg: 1000,
  },
  {
    asset: 'car',
    subtitleKey: 'shareable.volumeCompare.car.subtitle',
    weightKg: 1500,
  },
  {
    asset: 'van',
    subtitleKey: 'shareable.volumeCompare.van.subtitle',
    weightKg: 2000,
  },
  {
    asset: 'pickupTruck',
    subtitleKey: 'shareable.volumeCompare.pickupTruck.subtitle',
    weightKg: 3000,
  },
  {
    asset: 'helicopter',
    subtitleKey: 'shareable.volumeCompare.helicopter.subtitle',
    weightKg: 5000,
  },
  {
    asset: 'elephant',
    subtitleKey: 'shareable.volumeCompare.elephant.subtitle',
    weightKg: 6000,
  },
  {
    asset: 'trex',
    subtitleKey: 'shareable.volumeCompare.trex.subtitle',
    weightKg: 7000,
  },
  {
    asset: 'yacht',
    subtitleKey: 'shareable.volumeCompare.yacht.subtitle',
    weightKg: 8000,
  },
  {
    asset: 'truck',
    subtitleKey: 'shareable.volumeCompare.truck.subtitle',
    weightKg: 10000,
  },
  {
    asset: 'bus',
    subtitleKey: 'shareable.volumeCompare.bus.subtitle',
    weightKg: 15000,
  },
  {
    asset: 'jet',
    subtitleKey: 'shareable.volumeCompare.jet.subtitle',
    weightKg: 20000,
  },
  {
    asset: 'airplane',
    subtitleKey: 'shareable.volumeCompare.airplane.subtitle',
    weightKg: 40000,
  },
] as const;

export const getVolumeComparison = (volumeKg: number) => {
  if (volumeKg < VOLUME_COMPARISONS[0].weightKg) return undefined;

  for (let i = 1; i < VOLUME_COMPARISONS.length; i++) {
    if (volumeKg < VOLUME_COMPARISONS[i].weightKg) {
      return VOLUME_COMPARISONS[i - 1];
    }
  }

  return VOLUME_COMPARISONS[VOLUME_COMPARISONS.length - 1];
};

type EventShareable = EventPayload['shareables'][number];

export type EventVolumeComparison = {
  shareable: EventShareable;
  count: number;
};

// Event items are counted ("12 pumpkins"), not picked by threshold like the built-ins above.
export const getEventVolumeComparison = (
  shareables: readonly EventShareable[],
  volumeKg: number,
): EventVolumeComparison | undefined => {
  const affordable = shareables.filter(shareable => volumeKg >= shareable.weightKg);
  if (affordable.length === 0) return undefined;

  const heaviest = affordable.reduce((a, b) => (b.weightKg > a.weightKg ? b : a));

  return { shareable: heaviest, count: Math.floor(volumeKg / heaviest.weightKg) };
};
